<template>
  <v-container class="pt-0" fluid>
    <v-row align="center">
      <v-col cols="12">
        <tabela :items="items" :loading="loading" @rechargeTable="getAllToursPaginas()" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import TourService from '@/services/TourService';

  export default {
    components: {
      Tabela: () => import('@/components/tour/Tabela.vue')
    },

    data: () => ({
      items: [],
      loading: false
    }),

    mounted() {
      this.getAllToursPaginas();
    },

    methods: {
      getAllToursPaginas() {
        this.loading = true;

        TourService.getAllToursPaginas()
          .then((response) => (this.items = response.data.data))
          .catch(() => {
            this.$toast.error('Erro ao recuperar relação de tour das páginas', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>